var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contactum_settings_wrap" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "settings_content" }, [
      _c("div", { attrs: { id: "contactum-admin-settings" } }, [
        _c("div", { staticClass: "contactum_card", attrs: { id: "layout" } }, [
          _c("table", { staticClass: "form-table" }, [
            _c("tbody", [
              _c("tr", { staticClass: "contactum-label-position" }, [
                _c("th", [_vm._v(" Label Position ")]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "el-select",
                      {
                        model: {
                          value: _vm.settings.label_position,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "label_position", $$v)
                          },
                          expression: "settings.label_position"
                        }
                      },
                      _vm._l(_vm.label_positions, function(label_position) {
                        return _c("el-option", {
                          key: label_position.value,
                          attrs: {
                            label: label_position.label,
                            value: label_position.value
                          }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v(" Where the labels of the form should display ")
                    ])
                  ],
                  1
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contactum_card", attrs: { id: "confirmation" } },
          [
            _c("table", { staticClass: "form-table" }, [
              _c("tbody", [
                _c("tr", { staticClass: "contactum-redirect-to" }, [
                  _c("th", [_vm._v(" Redirect To ")]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.settings.redirect_to,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "redirect_to", $$v)
                            },
                            expression: "settings.redirect_to"
                          }
                        },
                        _vm._l(_vm.redirects_to, function(redirect_to) {
                          return _c("el-option", {
                            key: redirect_to.value,
                            attrs: {
                              label: redirect_to.label,
                              value: redirect_to.value
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "description" }, [
                        _vm._v(
                          " After successful submit, where the page will redirect to. This redirect option will not work if Show Report in Frontend option is enabled "
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settings.redirect_to == "same",
                        expression: "settings.redirect_to == 'same'"
                      }
                    ],
                    staticClass: "contactum-same-page"
                  },
                  [
                    _c("th", [_vm._v(" Message to show ")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("wp_editor", {
                          attrs: { value: _vm.settings.message },
                          on: { "content-changed": _vm.onEditorContentChange }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settings.redirect_to == "page",
                        expression: "settings.redirect_to == 'page'"
                      }
                    ],
                    staticClass: "contactum-page-id"
                  },
                  [
                    _c("th", [_vm._v(" Page ")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.settings.page_id,
                              callback: function($$v) {
                                _vm.$set(_vm.settings, "page_id", $$v)
                              },
                              expression: "settings.page_id"
                            }
                          },
                          _vm._l(_vm.settings.pages, function(page, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: index, value: page }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settings.redirect_to == "url",
                        expression: "settings.redirect_to == 'url'"
                      }
                    ],
                    staticClass: "contactum-url"
                  },
                  [
                    _c("th", [_vm._v(" Custom URL ")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: { type: "url" },
                          model: {
                            value: _vm.settings.url,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "url", $$v)
                            },
                            expression: "settings.url"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("tr", { staticClass: "contactum-submit-text" }, [
                  _c("th", [_vm._v(" Submit Button text ")]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("el-input", {
                        staticClass: "regular-text",
                        attrs: { type: "text" },
                        model: {
                          value: _vm.settings.submit_text,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "submit_text", $$v)
                          },
                          expression: "settings.submit_text"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contactum_card", attrs: { id: "scheduling" } },
          [
            _c("table", { staticClass: "form-table" }, [
              _c("tbody", [
                _c("tr", { staticClass: "contactum-schedule-entries" }, [
                  _c("th", [_vm._v(" Schedule form ")]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "label",
                      { staticClass: "contactum-switch" },
                      [
                        _c("el-checkbox", {
                          model: {
                            value: _vm.settings.schedule_form,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "schedule_form", $$v)
                            },
                            expression: "settings.schedule_form"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "switch-slider round" }),
                        _vm._v(" Schedule form for a period\n              ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v(" Schedule for a time period the form is active. ")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settings.schedule_form == true,
                        expression: "settings.schedule_form == true "
                      }
                    ],
                    staticClass: "contactum-schedule-period"
                  },
                  [
                    _c("th", [_vm._v(" Schedule Period ")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "schedule-field" }, [
                      _c(
                        "div",
                        { staticClass: "label" },
                        [
                          _vm._v(" From "),
                          _c("el-date-picker", {
                            attrs: { type: "date", placeholder: "From" },
                            model: {
                              value: _vm.settings.schedule_start,
                              callback: function($$v) {
                                _vm.$set(_vm.settings, "schedule_start", $$v)
                              },
                              expression: "settings.schedule_start"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "label" },
                        [
                          _vm._v(" To "),
                          _c("el-date-picker", {
                            attrs: { type: "date", placeholder: "To" },
                            model: {
                              value: _vm.settings.schedule_end,
                              callback: function($$v) {
                                _vm.$set(_vm.settings, "schedule_end", $$v)
                              },
                              expression: "settings.schedule_end"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settings.schedule_form == true,
                        expression: "settings.schedule_form == true"
                      }
                    ],
                    staticClass: "contactum-schedule-pending"
                  },
                  [
                    _c("th", [_vm._v(" Form Pending Message ")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("wp_editor", {
                          attrs: { value: _vm.settings.sc_pending_message },
                          on: { "content-changed": _vm.onEditorContentChange }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settings.schedule_form == true,
                        expression: "settings.schedule_form == true"
                      }
                    ],
                    staticClass: "contactum-schedule-expired"
                  },
                  [
                    _c("th", [_vm._v(" Form Expired Message ")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("wp_editor", {
                          attrs: { value: _vm.settings.sc_expired_message }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("tr", { staticClass: "contactum-require-login" }, [
                  _c("th", [_vm._v(" Require Login ")]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "label",
                      { staticClass: "contactum-switch" },
                      [
                        _c("el-checkbox", {
                          model: {
                            value: _vm.settings.require_login,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "require_login", $$v)
                            },
                            expression: "settings.require_login"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "switch-slider round" }),
                        _vm._v(" Require user to be logged in\n              ")
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settings.require_login == true,
                        expression: "settings.require_login == true"
                      }
                    ],
                    staticClass: "contactum-limit-message"
                  },
                  [
                    _c("th", [_vm._v(" Require Login Message ")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("wp_editor", {
                          attrs: { value: _vm.settings.req_login_message },
                          on: { "content-changed": _vm.onEditorContentChange }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("tr", { staticClass: "contactum-limit-entries" }, [
                  _c("th", [_vm._v(" Limit Entries ")]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "label",
                      { staticClass: "contactum-switch" },
                      [
                        _c("el-checkbox", {
                          model: {
                            value: _vm.settings.limit_entries,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "limit_entries", $$v)
                            },
                            expression: "settings.limit_entries"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "switch-slider round" }),
                        _vm._v(" Enable form entry limit\n              ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v(
                        " Limit the number of entries allowed for this form "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settings.limit_entries == true,
                        expression: "settings.limit_entries == true"
                      }
                    ],
                    staticClass: "contactum-number-entries"
                  },
                  [
                    _c("th", [_vm._v(" Number of Entries ")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: { type: "number" },
                          model: {
                            value: _vm.settings.limit_number,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "limit_number", $$v)
                            },
                            expression: "settings.limit_number"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settings.limit_entries == true,
                        expression: "settings.limit_entries == true"
                      }
                    ],
                    staticClass: "contactum-limit-message"
                  },
                  [
                    _c("th", [_vm._v(" Limit Reached Message ")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("wp_editor", {
                          attrs: { value: _vm.settings.limit_message },
                          on: { "content-changed": _vm.onEditorContentChange }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contactum_card", attrs: { id: "custom-css-js" } },
          [
            _c("table", { staticClass: "form-table" }, [
              _c("tbody", [
                _c("tr", { staticClass: "contactum-use-theme-css" }, [
                  _c("th", [_vm._v(" Use Theme CSS")]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.settings.use_theme_css,
                            expression: "settings.use_theme_css"
                          }
                        ],
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.settings,
                              "use_theme_css",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "contactum-theme-style" } },
                          [_vm._v(" Yes ")]
                        ),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "contactum-style" } }, [
                          _vm._v(" No ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ])
                ]),
                _vm._v(" "),
                _c("tr", { attrs: { id: "custom-css-js" } }, [
                  _c("th", [_vm._v(" Custom Css ")]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "div",
                      [
                        _c("p", [
                          _vm._v(
                            "You can write your custom CSS here for this form. This css will be applied in this current form only. You may add #contactum_form_" +
                              _vm._s(_vm.id) +
                              " as your css selector prefix to target this specific form. "
                          )
                        ]),
                        _vm._v(" "),
                        _c("AceCSSEditor", {
                          attrs: { mode: "css" },
                          model: {
                            value: _vm.settings.custom_css,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "custom_css", $$v)
                            },
                            expression: "settings.custom_css"
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v(" Please don't include tag ")])
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(" Custom JS " + _vm._s(_vm.settings.custom_js) + " ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "div",
                      [
                        _c("p", [
                          _vm._v(
                            "Your additional JS code will run after this form initialized. Please provide valid javascript code. Invalid JS code may break the Form. The Following Javascript variables are available that you can use : $form: The Javascript(jQuery) DOM object of the Form"
                          )
                        ]),
                        _vm._v(" "),
                        _c("AceJSEditor", {
                          attrs: { mode: "javascript" },
                          model: {
                            value: _vm.settings.custom_js,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "custom_js", $$v)
                            },
                            expression: "settings.custom_js"
                          }
                        }),
                        _vm._v(" Please don't include tag\n              ")
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contactum_settings_sidebar_wrap" }, [
      _c(
        "span",
        {
          staticClass: "contactum_sidebar_toggle",
          attrs: { title: "Toggle Setting" }
        },
        [_c("i", { staticClass: "ff-icon ff-icon-arrow-right" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "contactum_settings_sidebar contactum_layout_section_sidebar"
        },
        [
          _c(
            "ul",
            { staticClass: "contactum_settings_list contactum_list_button" },
            [
              _c(
                "li",
                { staticClass: "contactum_list_button_item has_sub_menu" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "contactum_list_button_link",
                      attrs: { href: "#" }
                    },
                    [_vm._v(" Settings ")]
                  ),
                  _vm._v(" "),
                  _c("ul", { staticClass: "contactum_list_submenu" }, [
                    _c("li", { staticClass: "contactum_list_button_item" }, [
                      _c("a", { attrs: { href: "#layout" } }, [
                        _vm._v(" Form Layout ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "contactum_list_button_item" }, [
                      _c("a", { attrs: { href: "#confirmation" } }, [
                        _vm._v(" Confirmation Settings ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "contactum_list_button_item" }, [
                      _c("a", { attrs: { href: "#scheduling" } }, [
                        _vm._v(" Scheduling & Restrictions ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "contactum_list_button_item" }, [
                      _c("a", { attrs: { href: "#custom-css-js" } }, [
                        _vm._v(" custom css & js")
                      ])
                    ])
                  ])
                ]
              )
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "description" }, [
      _vm._v(" Selecting "),
      _c("strong", [_vm._v("Yes")]),
      _vm._v(" will use your theme's style for form fields. ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }